import { useCallback } from 'react';

import { useAnalyticsService } from './analytics';
import { EventAttributes } from './types';

export function useEvent(prefix?: string | undefined) {
  const { trackSatellite, setDigitalData } = useAnalyticsService();
  const eventPrefix = prefix ?? 'identity';

  const trackEvent = useCallback(
    async (
      eventName: string,
      title: string,
      trackSuffix: string,
      eventAttributes: Omit<EventAttributes, 'title'> = {},
      wait = false,
    ) => {
      const event = {
        eventInfo: {
          eventName,
        },
        attributes: {
          title,
          ...eventAttributes,
        },
      };

      setDigitalData('event', [event]);

      trackSatellite(`${eventPrefix}_${trackSuffix}`);

      if (wait) {
        await new Promise(resolve => setTimeout(resolve, 400));
      }
    },
    [eventPrefix, setDigitalData, trackSatellite],
  );

  return trackEvent;
}
